import { LotteryConfigModel } from "@sazka/lotteries/js/utils/lottery-configs/models/lottery-configuration-model";
import { reactive } from "vue";

const state: Partial<LotteryConfigModel> = reactive({});

export const usePpWagerConfiguration = () => {
    const configure = (config: Partial<LotteryConfigModel>) => {
        Object.assign(state, config);
    };

    return {
        configure,
        config: state,
    };
};
